var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 6.00001c0-.49706-.40294-.9-.89999-.9-.49706 0-.9.40294-.9.9V10.5c0 .3752.23271.711.58399.8427l4 1.5c.4654.1745.9842-.0613 1.1587-.5267.1745-.4654-.0613-.9842-.5267-1.1587L10.4 9.87631v-3.8763z",
    fill: "#99A2AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 .100006C4.53239.100006.100006 4.53239.100006 10c0 5.4676 4.432384 9.9 9.899994 9.9 5.4676 0 9.9-4.4324 9.9-9.9 0-5.46761-4.4324-9.899994-9.9-9.899994zM1.90001 10c0-4.4735 3.62649-8.09999 8.09999-8.09999S18.1 5.5265 18.1 10s-3.6265 8.1-8.1 8.1-8.09999-3.6265-8.09999-8.1z",
    fill: "#99A2AD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentIcon);
export default __webpack_public_path__ + "static/media/recent-icon.50cb0581.svg";
export { ForwardRef as ReactComponent };